import { ViewModel,View, ObservableArray } from "binder"
import moment from "moment";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile, getAsBoolean, getAsNumber } from "src/uicomponents/components/utilities";
import { FileSelectorViewModel, PaginationInfo, ServerSideDataLoader } from "uicomponents";
import  { RequestsListView } from "./requestsList-view"

export class RequestsListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'لیست درخواست ها';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.rows = ObservableArray.create<items>();
        this.canExportExcel = true;
        this.loader = new ServerSideDataLoader((filteringInformation,exportType)=>this.refreshPaged(filteringInformation,exportType),30);
        this.refresh();
    }

    GetDefaultView(): View <ViewModel> {
        return new RequestsListView();
    }
    public getTypeId(): string {
        return "VM-335CD35B-CD1E-4D5D-9CE9-1F362F13B516"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set rows(v: ObservableArray<items>) { this._rows = v; } public get rows(): ObservableArray<items> { return this._rows;} private _rows: ObservableArray<items>;
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set canExportExcel(v: boolean) { this._canExportExcel = v; } public get canExportExcel(): boolean { return this._canExportExcel;} private _canExportExcel: boolean;
    
    exportExcel(){
        this.loader.refreshExport(".xlsx");

    }
    refresh() {
        this.loader.refresh();
    }
    async callServer(filteringInformation: any,exportType?:string) : Promise<any>{
        let request = {
            ProcessId: "696987B3-D0F2-408B-A79E-A8D89F42F108",
            FurtherQueryInfo: filteringInformation,
            ExportExcel : stringIsNullOrEmpty(exportType)==false ? true : undefined 
        };
        let result = await ServerConnection.callServer('/Complex/IndominServices/GetAllInstances',request);
        return result;
    }
    async refreshPaged(filteringInformation: any,exportType?:string): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result =await this.callServer(filteringInformation,exportType);
            if(result.IsExport==true){
                downloadFile(result.ExcelExportData,'لیست درخواست های متقاضیان.xlsx');
                return ServerSideDataLoader.UnchangedPaginationInfo;
            }
            this.rows.update(...result.Rows.map(y=>{
                let row = new items(this);
                let x = JSON.parse(y.Info);

                row.id = y.Id;

                row.isJuridical = x.isJuridical;
                row.naturalPersonName = x.naturalPersonName;
                row.naturalPersonLastName = x.naturalPersonLastName;
                row.naturalPersonBirthDate = x.naturalPersonBirthDate == null ? null : moment.utc(x.naturalPersonBirthDate);
                row.naturalpersonNationalCode = x.naturalpersonNationalCode;
                row.juridicalPersonCompanyName = x.juridicalPersonCompanyName;
                row.juridicalPersonCreationDate = x.juridicalPersonCreationDate == null ? null : moment.utc(x.juridicalPersonCreationDate);
                row.juridicalPersonIdentificationCode = x.juridicalPersonIdentificationCode;
                row.cellPhone = x.cellPhone;
                row.phone = x.phone;
                row.email = x.email;
                row.provinceName = x.provinceName;
                row.cityName = x.cityName;
                row.yearsExperience = x.yearsExperience;
                row.monthesExpreince = x.monthesExpreince;
                row.selectedWorkType = x.workTypeName;
                row.CashBuy = x.CashBuy;
                row.credit = x.credit;
                row.ownership = x.ownership;
                row.businessLicense = x.businessLicense;
                row.area = x.area;
                row.hasWarehouse = x.hasWarehouse;
                row.warehouseArea = x.warehouseArea;
                row.name = x.name;
                row.relatedDate = x.relatedDate==null ? null : moment.utc(x.relatedDate);
                row.nationalCode = x.nationalCode;
                row.resellerScore = x.resellerScore;
                row.status = x.status;
                row.statusName = x.statesName;
                for(let i=0;i<100;i++){
                    if(x[`file${i}Id`]){
                        let file = new singleShowingFile(this);
                        file.id= x[`file${i}Id`];
                        file.fileName = x[`file${i}Name`];
                        file.reason  = x[`file${i}Reason`];
                        row.files.push(file);
                    }
                }
                return row;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
}
export class items extends ViewModel implements IPopup{
    public getTypeId(): string {return 'row';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.files = ObservableArray.create<singleShowingFile>();
    }

    closePopup(result: any = null) {
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    
    public set isJuridical(v: boolean) { this._isJuridical = v; } public get isJuridical(): boolean { return this._isJuridical;} private _isJuridical: boolean;
    public set naturalPersonName(v: string) { this._naturalPersonName = v; } public get naturalPersonName(): string { return this._naturalPersonName;} private _naturalPersonName: string;
    public set naturalPersonLastName(v: string) { this._naturalPersonLastName = v; } public get naturalPersonLastName(): string { return this._naturalPersonLastName;} private _naturalPersonLastName: string;
    public set naturalPersonBirthDate(v: moment.Moment) { this._naturalPersonBirthDate = v; } public get naturalPersonBirthDate(): moment.Moment { return this._naturalPersonBirthDate;} private _naturalPersonBirthDate: moment.Moment;
    public set naturalpersonNationalCode(v: string) { this._naturalpersonNationalCode = v; } public get naturalpersonNationalCode(): string { return this._naturalpersonNationalCode;} private _naturalpersonNationalCode: string;
    public set juridicalPersonCompanyName(v: string) { this._juridicalPersonCompanyName = v; } public get juridicalPersonCompanyName(): string { return this._juridicalPersonCompanyName;} private _juridicalPersonCompanyName: string;
    public set juridicalPersonCreationDate(v: moment.Moment) { this._juridicalPersonCreationDate = v; } public get juridicalPersonCreationDate(): moment.Moment { return this._juridicalPersonCreationDate;} private _juridicalPersonCreationDate: moment.Moment;
    public set juridicalPersonIdentificationCode(v: string) { this._juridicalPersonIdentificationCode = v; } public get juridicalPersonIdentificationCode(): string { return this._juridicalPersonIdentificationCode;} private _juridicalPersonIdentificationCode: string;
    public set cellPhone(v: string) { this._cellPhone = v; } public get cellPhone(): string { return this._cellPhone;} private _cellPhone: string;
    public set phone(v: string) { this._phone = v; } public get phone(): string { return this._phone;} private _phone: string;
    public set email(v: string) { this._email = v; } public get email(): string { return this._email;} private _email: string;
    public set provinceName(v: string) { this._provinceName = v; } public get provinceName(): string { return this._provinceName;} private _provinceName: string;
    public set cityName(v: string) { this._cityName = v; } public get cityName(): string { return this._cityName;} private _cityName: string;
    public set yearsExperience(v: number) { this._yearsExperience = getAsNumber(v,true); } public get yearsExperience(): number { return this._yearsExperience;} private _yearsExperience: number;
    public set monthesExpreince(v: number) { this._monthesExpreince = getAsNumber(v,true); } public get monthesExpreince(): number { return this._monthesExpreince;} private _monthesExpreince: number;
    public set selectedWorkType(v: string) { this._selectedWorkType = v; } public get selectedWorkType(): string { return this._selectedWorkType;} private _selectedWorkType: string;
    public set CashBuy(v: boolean) { this._CashBuy = getAsBoolean(v); } public get CashBuy(): boolean { return this._CashBuy;} private _CashBuy: boolean;
    public set credit(v: number) { this._credit = getAsNumber(v,true); } public get credit(): number { return this._credit;} private _credit: number;
    public set ownership(v: boolean) { this._ownership = getAsBoolean(v); } public get ownership(): boolean { return this._ownership;} private _ownership: boolean;
    public set businessLicense(v: boolean) { this._businessLicense = getAsBoolean(v); } public get businessLicense(): boolean { return this._businessLicense;} private _businessLicense: boolean;
    public set area(v: number) { this._area = getAsNumber(v,true); } public get area(): number { return this._area;} private _area: number;
    public set hasWarehouse(v: boolean) { this._hasWarehouse = getAsBoolean(v); } public get hasWarehouse(): boolean { return this._hasWarehouse;} private _hasWarehouse: boolean;
    public set warehouseArea(v: number) { this._warehouseArea = getAsNumber(v,true); } public get warehouseArea(): number { return this._warehouseArea;} private _warehouseArea: number;

    public set name(v: string) { this._name = v; } public get name(): string { return this._name;} private _name: string;
    public set relatedDate(v: moment.Moment) { this._relatedDate = v; } public get relatedDate(): moment.Moment { return this._relatedDate;} private _relatedDate: moment.Moment;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
 
    public set resellerScore(v: number) { this._resellerScore = v; } public get resellerScore(): number { return this._resellerScore;} private _resellerScore: number;
    public set status(v: string) { this._status = v; } public get status(): string { return this._status;} private _status: string;
    public set statusName(v: string) { this._statusName = v; } public get statusName(): string { return this._statusName;} private _statusName: string;
    
    public set files(v: ObservableArray<singleShowingFile>) { this._files = v; } public get files(): ObservableArray<singleShowingFile> { return this._files;} private _files: ObservableArray<singleShowingFile>;
    

    showDetail(){
        this.requestShowingPopup(this);
    }

    addFiles(){
        let popup = new addFiles(this);
        popup.instanceId = this.id;
        popup.setJuridicalType(this.isJuridical);
        this.requestShowingPopup(popup);
    }
}
export class singleShowingFile extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        
    }
    
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason;} private _reason: string;
    public set fileName(v: string) { this._fileName = v; } public get fileName(): string { return this._fileName;} private _fileName: string;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    async download(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/IndominServices/DownloadFile',{
                Id:this.id
            })
            downloadFile(result.Content,this.fileName);
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}
export class addFiles extends ViewModel implements IPopup{
    public getTypeId(): string {return 'update';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel) {
        super(parent);
        this.files = ObservableArray.create<fileSelector>();
    }
    closePopup(result: any= null) {

    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set instanceId(v: string) { this._instanceId = v; } public get instanceId(): string { return this._instanceId;} private _instanceId: string;
    public set files(v: ObservableArray<fileSelector>) { this._files = v; } public get files(): ObservableArray<fileSelector> { return this._files;} private _files: ObservableArray<fileSelector>;
    
    setJuridicalType(isJuridical : boolean){
        if(isJuridical){
            this.files.push(new fileSelector(this,'احراز هویت شرکت'));
            this.files.push(new fileSelector(this,'روزنامه رسمی'));
            this.files.push(new fileSelector(this,'اساس نامه'));
            this.files.push(new fileSelector(this,'شناسه اقتصادی'));
            this.files.push(new fileSelector(this,'جواز کسب'));
            this.files.push(new fileSelector(this,'سند/اجاره نامه'));
            this.files.push(new fileSelector(this,'تاییدیه حساب بانکی'));
            this.files.push(new fileSelector(this,'آدرس و کد پستی'));
        }else{
            this.files.push(new fileSelector(this,'شناسنامه'));
            this.files.push(new fileSelector(this,'کارت ملی'));
            this.files.push(new fileSelector(this,'تاییدیه کدپستی'));
            this.files.push(new fileSelector(this,'جواز کسب'));
            this.files.push(new fileSelector(this,'سند/اجاره نامه'));
            this.files.push(new fileSelector(this,'تاییدیه حساب بانکی'));
            this.files.push(new fileSelector(this,'آدرس و کد پستی'));
        }
    }
    async confirm(){
        try {
            this.isLoading = true;
            if(this.files.filter(x=>x.file.isFileChoosed()==false).length>0){
                this.messageBoxConfirmWarning('لطفا تمامی فایل های مورد نظر را تنظیم نمایید','خطا در ثبت داده');
                return;
            }
            let result = await ServerConnection.callServer('/Complex/IndominServices/UpdateData',{
                Id : this.instanceId,
                ProcessId:"696987B3-D0F2-408B-A79E-A8D89F42F108",
                Files : this.files.map(x=>{
                    return {
                        Reason : x.reason,
                        Name : x.file.filename,
                        Content : x.file.filecontent   
                    }
                })
            });     
            if(result.IsSuccessful){
                await this.messageBoxConfirmSuccess('عملیات با موفقیت انجام شد.','ثبت داده');
            }else{
                this.messageBoxConfirmWarning('خطایی رح داده است.','خطا در ثبت داده');
                return;
            }
        } catch (ex) {
            this.messageBoxConfirmWarning('خطایی رح داده است.','خطا در ثبت داده');
            console.log(ex);
            return;
        } finally {
            this.isLoading = false;
        }
        this.closePopup(true);
    }
}

export class fileSelector extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:ViewModel,reason : string) {
        super(parent);

        this.reason = reason;
        this.file = new FileSelectorViewModel(this,500); 
    }
    
    public set file(v: FileSelectorViewModel) { this._file = v; } public get file(): FileSelectorViewModel { return this._file;} private _file: FileSelectorViewModel;
    public set reason(v: string) { this._reason = v; } public get reason(): string { return this._reason;} private _reason: string;
    
}

export class UserRequestsList extends RequestsListViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.canExportExcel = false;
    }
    override async callServer(filteringInformation: any,exportType?:string){
        let result = await ServerConnection.callServer('/Complex/IndominServices/GetUserInstances',{
            ProcessId:"696987B3-D0F2-408B-A79E-A8D89F42F108",
            FurtherQueryInfo:filteringInformation
        });
        return result;
    }
}